// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home{
    display:flex;
    flex-direction: column;
    

}
.intro{
    padding: 5% 0;
    width:100vw;
    height:100%;
    
    display:flex;
    flex-direction: row;
}
.intro-content{
    width:50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}


.intro img{
    height:70%;
    margin-left: 5%;
    border-radius:10px;
}

.intro-left{
        padding: 5% 0;
        width: 100vw;
        height: 100%;
    
        display: flex;
        flex-direction: row;
}

.intro-left img{
    height:70%;
    
    margin-left: 8%;;
    border-radius: 10px;
}
.intro-content-left{
    
            width: 50%;
            margin-left: 5%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            
    
}


.intro h1 {
    font-family: "Dancing Script", cursive;
    font-weight: 400;
    font-style: normal;
    color:#FF3C4E;
    font-size: 46px;
}

.intro-left h1 {
    font-family: "Dancing Script", cursive;
    font-weight: 400;
    font-style: normal;
    color: #FF3C4E;
    font-size: 46px;
}

.intro h2{
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size: 42px;
}

.intro-left h2 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size: 42px;
}

.intro p{
    font-family: 'Inter', sans-serif;
    width:50%;
    font-weight: 400;
    font-size: 15.63px;
    line-height: 30px;
    letter-spacing: 1px;
    /* color:#777777; */
}

.intro-left p{
    font-family: 'Inter', sans-serif;
    width: 50%;
    font-weight: 400;
    font-size: 15.63px;
    line-height: 30px;
    letter-spacing: 1px;
    /* color: #777777; */
}

.intro button{
        color: #fff;
        background-color: #FF3C4E;
        width: 131.52px;
        height: 42px;
        border-radius: 25px;
        text-decoration: underline;
            position: relative;
            overflow: hidden;
            cursor: pointer;
        
            z-index: 1
}


.intro button::after {
    /* this is what all  will be done when mouse outs from the button */
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #F2C713;
    z-index: -1;
    border-radius: 10rem;
    transition: 0.3s ease all;
    transform: scale(0, 1);

    /* this is you are to change for diffirent transition; */

    transform-origin: bottom left;
    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}

.intro button:hover::after {
    transform: scale(1, 1);
    transform-origin: top left;
}



.intro-left button {
    color: #fff;
    background-color: #FF3C4E;
    width: 131.52px;
    height: 42px;
    border-radius: 25px;
    text-decoration: underline;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    z-index: 1
}


.intro-left button::after {
    /* this is what all  will be done when mouse outs from the button */
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #F2C713;
    z-index: -1;
    border-radius: 10rem;
    transition: 0.3s ease all;
    transform: scale(0, 1);

    /* this is you are to change for diffirent transition; */

    transform-origin: bottom left;
    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}

.intro-left button:hover::after {
    transform: scale(1, 1);
    transform-origin: top left;
}




.product-card{
    background-color: #fff;
    width:300px;
    height:450px;
    margin:30px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    flex-shrink: 0;
    
}

.product-card img{
    width:70%;
    height:50%;
    margin-top: 10px;
}

.product-card p{
    font-family: 'Poppins', sans-serif;
    width: 70%;
    font-weight: 500;
   
}
.price-details{
    display: flex;
    flex-direction: row;
    
}

.price-details p{
    margin:10px 0px;
}

.add-cart{
    display: flex;
    flex-direction: row;
   

}
.add-cart p{
    font-size: small;
    width:100%;
}

.scroll-cards{
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.right-scroll,.left-scroll{
    width:40px;
    height:30px;
    background-color: #FFF;
    margin:5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border:none;

}

.right-scroll{
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}

.left-scroll{
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}


.product-advantages{
    background-color:  #F2C713; 
    margin:0;
}

.product-advantages svg{
   position: relative;
    left:1px;
    bottom:-3px;
}

.advantages ul{
    display: flex;
    flex-direction: row;
    list-style-type: none;
    justify-content: space-evenly;
}

.advantage-card{
    width:15%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}


.advantage-card h4{
 font-family: 'Poppins', sans-serif;
 font-weight: 600;
}

.advantage-card p{
    width:100%;
    text-align:justify;
    font-family: 'Poppins', sans-serif;
    

}

.advantage-card img{
    width:250px;
}

.distributions{
    display: flex;
    justify-content: space-evenly;
    margin: 100px 0px;

}

.distributors{
    width:40%;
    height:300px;
    background-color: #095E3C;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom:30px;
    border-radius: 10px;
}

.distributors img{
    width:60%;

}

.distributors p{
    font-family: 'Poppins', sans-serif;
    font-size: x-large;
    color:#fff;
}

.distributors button{
    width:200px;
    height:50px;
    border-radius: 5px;
    border: none;
    background-color: #E42727;
    font-family: 'Poppins', sans-serif;
    font-size: larger;
   

}




.money-back{
    width:40%;
    height:330px;
    background-color: #E42727;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px;
    
}

.money-back ul{
    list-style-type: none;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    padding:20px;
}

.money-back ul p{
    font-family: 'Poppins', sans-serif;
    font-size: large;
    color: #fff;
    margin-top: 50px;
}



.blogs{
    padding:30px 0px;
    /* padding-top:50px; */
}

.blogs h1{
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    margin-top: 0px;
    margin-bottom: 20px;
}

.blogs ul{
    list-style-type: none;
    display: flex;
    justify-content: space-evenly;
}
.blog-post{
    width:350px;
    height:100%;
    margin-right: 30px;
    cursor:pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.blog-post img{
    width:100%;
    height:220px;
    border-radius: 10px;
    
}

.blog-post img:hover{
    scale:1.1;

}
.blog-post h4{
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
}

.blog-post p{
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color:#666;
    text-align: left;
}

.license img{
  width:80%;
  height:80%;
}

.contact {
    height:100%;
    margin-top: 0px;
    
}

.contact img{
    width:100%;
    height:100%;
    margin:0px ;
    padding: 0px;
    margin-top: 50px;
    margin-bottom: -0px;

}

button{
    border:none
}

@media screen and (max-width:768px){
    .intro {
            padding: 5% 0;
            width: 100vw;
            height: 100%;
    
            display: flex;
            flex-direction: column;
        }
    
        .intro-content {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    
    
        .intro img {
            height: 70%;
            margin-left: 0%;
            border-radius: 10px;
        }
    
        .intro-left {
            padding: 5% 0;
            width: 100vw;
            height: 100%;
    
            display: flex;
            flex-direction: column;
        }
    
        .intro-left img {
            height: 70%;
            margin-left: 5%;
            ;
            border-radius: 10px;
        }
    
        .intro-content-left {
    
            width: 100%;
            margin-left: 0%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
    
    
        }
    
    
        .intro h1 {
            font-family: "Dancing Script", cursive;
            font-weight: 400;
            font-style: normal;
            color: #FF3C4E;
            font-size: 42px;
        }
    
        .intro-left h1 {
            font-family: "Dancing Script", cursive;
            font-weight: 400;
            font-style: normal;
            color: #FF3C4E;
            font-size: 42px;
        }
    
        .intro h2 {
            font-family: 'Raleway', sans-serif;
            font-weight: 700;
            font-size: 38px;
        }
    
        .intro-left h2 {
            font-family: 'Raleway', sans-serif;
            font-weight: 700;
            font-size: 38px;
        }
    
        .intro p {
            font-family: 'Inter', sans-serif;
            width: 70%;
            font-weight: 400;
            font-size: 15.63px;
            line-height: 30px;
            letter-spacing: 1px;
            color: #777777;
        }
    
        .intro-left p {
            font-family: 'Inter', sans-serif;
            width: 70%;
            font-weight: 400;
            font-size: 15.63px;
            line-height: 30px;
            letter-spacing: 1px;
            color: #777777;
        }
    
        .intro button {
            color: #fff;
            background-color: #FF3C4E;
            width: 131.52px;
            height: 42px;
            border-radius: 25px;
            text-decoration: underline;
            position: relative;
            overflow: hidden;
            cursor: pointer;
    
            z-index: 1
        }
    
    
        .intro button::after {
            /* this is what all  will be done when mouse outs from the button */
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            background-color: #F2C713;
            z-index: -1;
            border-radius: 10rem;
            transition: 0.3s ease all;
            transform: scale(0, 1);
    
            /* this is you are to change for diffirent transition; */
    
            transform-origin: bottom left;
            transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
            transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
        }
    
        .intro button:hover::after {
            transform: scale(1, 1);
            transform-origin: top left;
        }
    
    
    
        .intro-left button {
            color: #fff;
            background-color: #FF3C4E;
            width: 131.52px;
            height: 42px;
            border-radius: 25px;
            text-decoration: underline;
            position: relative;
            overflow: hidden;
            cursor: pointer;
    
            z-index: 1
        }
    
    
        .intro-left button::after {
            /* this is what all  will be done when mouse outs from the button */
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            background-color: #F2C713;
            z-index: -1;
            border-radius: 10rem;
            transition: 0.3s ease all;
            transform: scale(0, 1);
    
            /* this is you are to change for diffirent transition; */
    
            transform-origin: bottom left;
            transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
            transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
        }
    
        .intro-left button:hover::after {
            transform: scale(1, 1);
            transform-origin: top left;
        }
        .contact {
            height: 100%;
    
        }
        .contact img{
            margin-top:20px;
            margin-bottom: -50px;
        }

        
}

`, "",{"version":3,"sources":["webpack://./src/Styles/Home.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,sBAAsB;;;AAG1B;AACA;IACI,aAAa;IACb,WAAW;IACX,WAAW;;IAEX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA;QACQ,aAAa;QACb,YAAY;QACZ,YAAY;;QAEZ,aAAa;QACb,mBAAmB;AAC3B;;AAEA;IACI,UAAU;;IAEV,eAAe;IACf,mBAAmB;AACvB;AACA;;YAEY,UAAU;YACV,eAAe;YACf,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,mBAAmB;;;AAG/B;;;AAGA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;QACQ,WAAW;QACX,yBAAyB;QACzB,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,0BAA0B;YACtB,kBAAkB;YAClB,gBAAgB;YAChB,eAAe;;YAEf;AACZ;;;AAGA;IACI,mEAAmE;IACnE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;;IAEtB,wDAAwD;;IAExD,6BAA6B;IAC7B,0DAA0D;IAC1D,0DAA0D;AAC9D;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;;;AAIA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;;IAEf;AACJ;;;AAGA;IACI,mEAAmE;IACnE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;;IAEtB,wDAAwD;;IAExD,6BAA6B;IAC7B,0DAA0D;IAC1D,0DAA0D;AAC9D;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;;;;AAKA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;;AAElB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,UAAU;IACV,gBAAgB;;AAEpB;AACA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;;;AAGvB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;;AAEf;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;;AAGA;IACI,0BAA0B;IAC1B,QAAQ;AACZ;;AAEA;GACG,kBAAkB;IACjB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;;AAGA;CACC,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,kCAAkC;;;AAGtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;;AAErB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;;AAEb;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kCAAkC;IAClC,iBAAiB;;;AAGrB;;;;;AAKA;IACI,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;;;AAIA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,SAAS;;AAEb;AACA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,UAAU;IACV,gBAAgB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;IACI,WAAW;IACX,eAAe;;AAEnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI;AACJ;;AAEA;IACI;YACQ,aAAa;YACb,YAAY;YACZ,YAAY;;YAEZ,aAAa;YACb,sBAAsB;QAC1B;;QAEA;YACI,WAAW;YACX,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,mBAAmB;QACvB;;;QAGA;YACI,WAAW;YACX,eAAe;YACf,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,YAAY;YACZ,YAAY;;YAEZ,aAAa;YACb,sBAAsB;QAC1B;;QAEA;YACI,WAAW;YACX,eAAe;;YAEf,mBAAmB;QACvB;;QAEA;;YAEI,WAAW;YACX,eAAe;YACf,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,mBAAmB;;;QAGvB;;;QAGA;YACI,sCAAsC;YACtC,gBAAgB;YAChB,kBAAkB;YAClB,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,sCAAsC;YACtC,gBAAgB;YAChB,kBAAkB;YAClB,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,kCAAkC;YAClC,gBAAgB;YAChB,eAAe;QACnB;;QAEA;YACI,kCAAkC;YAClC,gBAAgB;YAChB,eAAe;QACnB;;QAEA;YACI,gCAAgC;YAChC,UAAU;YACV,gBAAgB;YAChB,kBAAkB;YAClB,iBAAiB;YACjB,mBAAmB;YACnB,cAAc;QAClB;;QAEA;YACI,gCAAgC;YAChC,UAAU;YACV,gBAAgB;YAChB,kBAAkB;YAClB,iBAAiB;YACjB,mBAAmB;YACnB,cAAc;QAClB;;QAEA;YACI,WAAW;YACX,yBAAyB;YACzB,eAAe;YACf,YAAY;YACZ,mBAAmB;YACnB,0BAA0B;YAC1B,kBAAkB;YAClB,gBAAgB;YAChB,eAAe;;YAEf;QACJ;;;QAGA;YACI,mEAAmE;YACnE,WAAW;YACX,kBAAkB;YAClB,OAAO;YACP,MAAM;YACN,YAAY;YACZ,WAAW;YACX,yBAAyB;YACzB,WAAW;YACX,oBAAoB;YACpB,yBAAyB;YACzB,sBAAsB;;YAEtB,wDAAwD;;YAExD,6BAA6B;YAC7B,0DAA0D;YAC1D,0DAA0D;QAC9D;;QAEA;YACI,sBAAsB;YACtB,0BAA0B;QAC9B;;;;QAIA;YACI,WAAW;YACX,yBAAyB;YACzB,eAAe;YACf,YAAY;YACZ,mBAAmB;YACnB,0BAA0B;YAC1B,kBAAkB;YAClB,gBAAgB;YAChB,eAAe;;YAEf;QACJ;;;QAGA;YACI,mEAAmE;YACnE,WAAW;YACX,kBAAkB;YAClB,OAAO;YACP,MAAM;YACN,YAAY;YACZ,WAAW;YACX,yBAAyB;YACzB,WAAW;YACX,oBAAoB;YACpB,yBAAyB;YACzB,sBAAsB;;YAEtB,wDAAwD;;YAExD,6BAA6B;YAC7B,0DAA0D;YAC1D,0DAA0D;QAC9D;;QAEA;YACI,sBAAsB;YACtB,0BAA0B;QAC9B;QACA;YACI,YAAY;;QAEhB;QACA;YACI,eAAe;YACf,oBAAoB;QACxB;;;AAGR","sourcesContent":[".home{\n    display:flex;\n    flex-direction: column;\n    \n\n}\n.intro{\n    padding: 5% 0;\n    width:100vw;\n    height:100%;\n    \n    display:flex;\n    flex-direction: row;\n}\n.intro-content{\n    width:50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n\n.intro img{\n    height:70%;\n    margin-left: 5%;\n    border-radius:10px;\n}\n\n.intro-left{\n        padding: 5% 0;\n        width: 100vw;\n        height: 100%;\n    \n        display: flex;\n        flex-direction: row;\n}\n\n.intro-left img{\n    height:70%;\n    \n    margin-left: 8%;;\n    border-radius: 10px;\n}\n.intro-content-left{\n    \n            width: 50%;\n            margin-left: 5%;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            \n    \n}\n\n\n.intro h1 {\n    font-family: \"Dancing Script\", cursive;\n    font-weight: 400;\n    font-style: normal;\n    color:#FF3C4E;\n    font-size: 46px;\n}\n\n.intro-left h1 {\n    font-family: \"Dancing Script\", cursive;\n    font-weight: 400;\n    font-style: normal;\n    color: #FF3C4E;\n    font-size: 46px;\n}\n\n.intro h2{\n    font-family: 'Raleway', sans-serif;\n    font-weight: 700;\n    font-size: 42px;\n}\n\n.intro-left h2 {\n    font-family: 'Raleway', sans-serif;\n    font-weight: 700;\n    font-size: 42px;\n}\n\n.intro p{\n    font-family: 'Inter', sans-serif;\n    width:50%;\n    font-weight: 400;\n    font-size: 15.63px;\n    line-height: 30px;\n    letter-spacing: 1px;\n    /* color:#777777; */\n}\n\n.intro-left p{\n    font-family: 'Inter', sans-serif;\n    width: 50%;\n    font-weight: 400;\n    font-size: 15.63px;\n    line-height: 30px;\n    letter-spacing: 1px;\n    /* color: #777777; */\n}\n\n.intro button{\n        color: #fff;\n        background-color: #FF3C4E;\n        width: 131.52px;\n        height: 42px;\n        border-radius: 25px;\n        text-decoration: underline;\n            position: relative;\n            overflow: hidden;\n            cursor: pointer;\n        \n            z-index: 1\n}\n\n\n.intro button::after {\n    /* this is what all  will be done when mouse outs from the button */\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #F2C713;\n    z-index: -1;\n    border-radius: 10rem;\n    transition: 0.3s ease all;\n    transform: scale(0, 1);\n\n    /* this is you are to change for diffirent transition; */\n\n    transform-origin: bottom left;\n    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n.intro button:hover::after {\n    transform: scale(1, 1);\n    transform-origin: top left;\n}\n\n\n\n.intro-left button {\n    color: #fff;\n    background-color: #FF3C4E;\n    width: 131.52px;\n    height: 42px;\n    border-radius: 25px;\n    text-decoration: underline;\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n\n    z-index: 1\n}\n\n\n.intro-left button::after {\n    /* this is what all  will be done when mouse outs from the button */\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #F2C713;\n    z-index: -1;\n    border-radius: 10rem;\n    transition: 0.3s ease all;\n    transform: scale(0, 1);\n\n    /* this is you are to change for diffirent transition; */\n\n    transform-origin: bottom left;\n    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n.intro-left button:hover::after {\n    transform: scale(1, 1);\n    transform-origin: top left;\n}\n\n\n\n\n.product-card{\n    background-color: #fff;\n    width:300px;\n    height:450px;\n    margin:30px 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    flex-shrink: 0;\n    \n}\n\n.product-card img{\n    width:70%;\n    height:50%;\n    margin-top: 10px;\n}\n\n.product-card p{\n    font-family: 'Poppins', sans-serif;\n    width: 70%;\n    font-weight: 500;\n   \n}\n.price-details{\n    display: flex;\n    flex-direction: row;\n    \n}\n\n.price-details p{\n    margin:10px 0px;\n}\n\n.add-cart{\n    display: flex;\n    flex-direction: row;\n   \n\n}\n.add-cart p{\n    font-size: small;\n    width:100%;\n}\n\n.scroll-cards{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n.right-scroll,.left-scroll{\n    width:40px;\n    height:30px;\n    background-color: #FFF;\n    margin:5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border:none;\n\n}\n\n.right-scroll{\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n}\n\n.left-scroll{\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n}\n\n\n.product-advantages{\n    background-color:  #F2C713; \n    margin:0;\n}\n\n.product-advantages svg{\n   position: relative;\n    left:1px;\n    bottom:-3px;\n}\n\n.advantages ul{\n    display: flex;\n    flex-direction: row;\n    list-style-type: none;\n    justify-content: space-evenly;\n}\n\n.advantage-card{\n    width:15%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n\n.advantage-card h4{\n font-family: 'Poppins', sans-serif;\n font-weight: 600;\n}\n\n.advantage-card p{\n    width:100%;\n    text-align:justify;\n    font-family: 'Poppins', sans-serif;\n    \n\n}\n\n.advantage-card img{\n    width:250px;\n}\n\n.distributions{\n    display: flex;\n    justify-content: space-evenly;\n    margin: 100px 0px;\n\n}\n\n.distributors{\n    width:40%;\n    height:300px;\n    background-color: #095E3C;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-bottom:30px;\n    border-radius: 10px;\n}\n\n.distributors img{\n    width:60%;\n\n}\n\n.distributors p{\n    font-family: 'Poppins', sans-serif;\n    font-size: x-large;\n    color:#fff;\n}\n\n.distributors button{\n    width:200px;\n    height:50px;\n    border-radius: 5px;\n    border: none;\n    background-color: #E42727;\n    font-family: 'Poppins', sans-serif;\n    font-size: larger;\n   \n\n}\n\n\n\n\n.money-back{\n    width:40%;\n    height:330px;\n    background-color: #E42727;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    border-radius: 10px;\n    \n}\n\n.money-back ul{\n    list-style-type: none;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    padding:20px;\n}\n\n.money-back ul p{\n    font-family: 'Poppins', sans-serif;\n    font-size: large;\n    color: #fff;\n    margin-top: 50px;\n}\n\n\n\n.blogs{\n    padding:30px 0px;\n    /* padding-top:50px; */\n}\n\n.blogs h1{\n    font-family: 'Poppins', sans-serif;\n    font-weight: 600;\n    margin-top: 0px;\n    margin-bottom: 20px;\n}\n\n.blogs ul{\n    list-style-type: none;\n    display: flex;\n    justify-content: space-evenly;\n}\n.blog-post{\n    width:350px;\n    height:100%;\n    margin-right: 30px;\n    cursor:pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.blog-post img{\n    width:100%;\n    height:220px;\n    border-radius: 10px;\n    \n}\n\n.blog-post img:hover{\n    scale:1.1;\n\n}\n.blog-post h4{\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    text-align: left;\n}\n\n.blog-post p{\n    font-family: 'Poppins', sans-serif;\n    font-size: 14px;\n    color:#666;\n    text-align: left;\n}\n\n.license img{\n  width:80%;\n  height:80%;\n}\n\n.contact {\n    height:100%;\n    margin-top: 0px;\n    \n}\n\n.contact img{\n    width:100%;\n    height:100%;\n    margin:0px ;\n    padding: 0px;\n    margin-top: 50px;\n    margin-bottom: -0px;\n\n}\n\nbutton{\n    border:none\n}\n\n@media screen and (max-width:768px){\n    .intro {\n            padding: 5% 0;\n            width: 100vw;\n            height: 100%;\n    \n            display: flex;\n            flex-direction: column;\n        }\n    \n        .intro-content {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n        }\n    \n    \n        .intro img {\n            height: 70%;\n            margin-left: 0%;\n            border-radius: 10px;\n        }\n    \n        .intro-left {\n            padding: 5% 0;\n            width: 100vw;\n            height: 100%;\n    \n            display: flex;\n            flex-direction: column;\n        }\n    \n        .intro-left img {\n            height: 70%;\n            margin-left: 5%;\n            ;\n            border-radius: 10px;\n        }\n    \n        .intro-content-left {\n    \n            width: 100%;\n            margin-left: 0%;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n    \n    \n        }\n    \n    \n        .intro h1 {\n            font-family: \"Dancing Script\", cursive;\n            font-weight: 400;\n            font-style: normal;\n            color: #FF3C4E;\n            font-size: 42px;\n        }\n    \n        .intro-left h1 {\n            font-family: \"Dancing Script\", cursive;\n            font-weight: 400;\n            font-style: normal;\n            color: #FF3C4E;\n            font-size: 42px;\n        }\n    \n        .intro h2 {\n            font-family: 'Raleway', sans-serif;\n            font-weight: 700;\n            font-size: 38px;\n        }\n    \n        .intro-left h2 {\n            font-family: 'Raleway', sans-serif;\n            font-weight: 700;\n            font-size: 38px;\n        }\n    \n        .intro p {\n            font-family: 'Inter', sans-serif;\n            width: 70%;\n            font-weight: 400;\n            font-size: 15.63px;\n            line-height: 30px;\n            letter-spacing: 1px;\n            color: #777777;\n        }\n    \n        .intro-left p {\n            font-family: 'Inter', sans-serif;\n            width: 70%;\n            font-weight: 400;\n            font-size: 15.63px;\n            line-height: 30px;\n            letter-spacing: 1px;\n            color: #777777;\n        }\n    \n        .intro button {\n            color: #fff;\n            background-color: #FF3C4E;\n            width: 131.52px;\n            height: 42px;\n            border-radius: 25px;\n            text-decoration: underline;\n            position: relative;\n            overflow: hidden;\n            cursor: pointer;\n    \n            z-index: 1\n        }\n    \n    \n        .intro button::after {\n            /* this is what all  will be done when mouse outs from the button */\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 0;\n            height: 100%;\n            width: 100%;\n            background-color: #F2C713;\n            z-index: -1;\n            border-radius: 10rem;\n            transition: 0.3s ease all;\n            transform: scale(0, 1);\n    \n            /* this is you are to change for diffirent transition; */\n    \n            transform-origin: bottom left;\n            transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n            transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n        }\n    \n        .intro button:hover::after {\n            transform: scale(1, 1);\n            transform-origin: top left;\n        }\n    \n    \n    \n        .intro-left button {\n            color: #fff;\n            background-color: #FF3C4E;\n            width: 131.52px;\n            height: 42px;\n            border-radius: 25px;\n            text-decoration: underline;\n            position: relative;\n            overflow: hidden;\n            cursor: pointer;\n    \n            z-index: 1\n        }\n    \n    \n        .intro-left button::after {\n            /* this is what all  will be done when mouse outs from the button */\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 0;\n            height: 100%;\n            width: 100%;\n            background-color: #F2C713;\n            z-index: -1;\n            border-radius: 10rem;\n            transition: 0.3s ease all;\n            transform: scale(0, 1);\n    \n            /* this is you are to change for diffirent transition; */\n    \n            transform-origin: bottom left;\n            transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n            transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n        }\n    \n        .intro-left button:hover::after {\n            transform: scale(1, 1);\n            transform-origin: top left;\n        }\n        .contact {\n            height: 100%;\n    \n        }\n        .contact img{\n            margin-top:20px;\n            margin-bottom: -50px;\n        }\n\n        \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
